import { z } from "zod";

import { eventTypeAppCardZod } from "../eventTypeAppCardZod";

export const appDataSchema = eventTypeAppCardZod.merge(
  z.object({
    templateId: z.string().optional(),
    templateName: z.string().optional(),
    requireSignatureBeforeMeeting: z.boolean().optional(),
    hostAlsoSigns: z.boolean().optional(),
  })
);

// Zignature uses a platform-level API key (ZIGNATURE_PLATFORM_API_KEY env var)
// for all API calls. Per-user OAuth credentials are not required.
export const appKeysSchema = z.object({
  client_id: z.string().optional(),
  client_secret: z.string().optional(),
});
